import { combineReducers } from 'redux'
import { tasksInProgress, accountingOverview, accountingOverviewPeriod, departmentOverview, projectsDashboardStats, projectsInDanger } from './dashboardReducer'
import { ITasksInProgress, IAccountingOverviewChartData, IDepartmentOverviewChart } from './../../../types/dashboard'
import { IProject, IProjectsDashboardStats } from '../../project/types/project'

export interface GlobalDashboardState {
  tasksInProgress: ITasksInProgress[]
  accountingOverview: IAccountingOverviewChartData
  accountingOverviewPeriod: string
  departmentOverview: IDepartmentOverviewChart
  projectsDashboardStats: IProjectsDashboardStats
  projectsInDanger: IProject[]
}

const globalDashboardApp = combineReducers<GlobalDashboardState>({
  tasksInProgress,
  accountingOverview,
  accountingOverviewPeriod,
  departmentOverview,
  projectsDashboardStats,
  projectsInDanger
})

export default globalDashboardApp
